import { BaseChannel } from "@/api/ws/channels/BaseChannel";

export class ApplicationPrivateChannel extends BaseChannel {
  name = "borrower_platform.applications";
  isPrivate = true;
}
